// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
}

.title h3{
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}
.required-symbol {
  color: red;
  margin-left: 5px;
}

.success-message {
  color: green;
  text-align: center;
  margin-top: 20px;
}

.info-message {
  color: blue;
  text-align: center;
  margin-top: 20px;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
.bordered-container {
  border: 1px solid #d3d3d3; 
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
  padding-bottom: 1%;
}
`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/usd-conversion-rate/usd-conversion-rate.component.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n}\n\n.title h3{\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n.required-symbol {\n  color: red;\n  margin-left: 5px;\n}\n\n.success-message {\n  color: green;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.info-message {\n  color: blue;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.error-message {\n  color: red;\n  margin-top: 10px;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n.bordered-container {\n  border: 1px solid #d3d3d3; \n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n  padding-bottom: 1%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
